import { reducer, initialStateBase } from './newCollection';

export const TYPE = 'DISCLAIMER';

export const urls = {
    getDisclaimer: lang => `/api/config/disclaimer?context_lang=${lang}`
};

export default (state = initialStateBase, action) => {
    switch (action.type) {
        case `RECEIVE_${TYPE}`:
            return reducer(state, {
                ...action,
                data: {
                    data: action.data.data
                }
            }, TYPE);
        default:
            return reducer(state, action, TYPE);
    }
};
